import React from 'react';
import PropTypes from 'prop-types';
import DrawerContext from '../context';

const DrawerToggle = ({ children }) => (
  <DrawerContext.Consumer>
    {({ toggle }) => children(toggle)}
  </DrawerContext.Consumer>
);

DrawerToggle.propTypes = {
  children: PropTypes.func
};

export default DrawerToggle;
